import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../../apps/frontend/src/context/ThemeStore';

import PercentileCardLight from '../../../../../apps/frontend/public/img/percentile-card-light.svg';
import PercentileCardDark from '../../../../../apps/frontend/public/img/percentile-card-dark.svg';
import PercentileCardMobileDark from '../../../../../apps/frontend/public/img/percentile-card-mobile-dark.svg';
import PercentileCardMobileLight from '../../../../../apps/frontend/public/img/percentile-card-mobile-light.svg';

import ProjectedPercentileCardLight from '../../../../../apps/frontend/public/img/projected-percentile-card-light.svg';
import ProjectedPercentileCardDark from '../../../../../apps/frontend/public/img/projected-percentile-card-dark.svg';
import ProjectedPercentileCardMobileDark from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-dark.svg';
import ProjectedPercentileCardMobileLight from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-light.svg';

import QuizrrLight from '../../../public/Images/QuizrrWhite.svg';
import QuizrrBlack from '../../../public/Images/QuizrrBlack.svg';
import { SparkleIcon } from '@phosphor-icons/react';

const PercentileCard = ({ percentileData, score, percentile, isProjected = false }) => {
  const { isDarkTheme } = useContext(ThemeContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    // Set initial state
    setIsMobile(mediaQuery.matches);

    // Listener for changes
    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return (
    <div
      className="h-[266px] rounded-xl flex-1 lg:flex-initial lg:min-w-0 flex-shrink-0"
      style={{
        backgroundImage: `url(${
          isDarkTheme
            ? isMobile
              ? isProjected
                ? ProjectedPercentileCardMobileDark
                : PercentileCardMobileDark
              : isProjected
                ? ProjectedPercentileCardDark
                : PercentileCardDark
            : isMobile
              ? isProjected
                ? ProjectedPercentileCardMobileLight
                : PercentileCardMobileLight
              : isProjected
                ? ProjectedPercentileCardLight
                : PercentileCardLight
        })`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
        backgroundSize: 'auto 100%',
      }}
    >
      <div className={`flex flex-col justify-between h-full ${isProjected ? 'py-6' : 'py-3'} px-4`}>
        {/* Top Content */}
        <div>
          <img src={isDarkTheme ? QuizrrLight : QuizrrBlack} alt="Quizrr Logo" className="h-[80px] w-[80px]" />
          <div
            className={`text-sm md:text-base flex flex-row items-center gap-2 mt-4 ${isProjected ? 'text-[var(--q3-teal-normal)]' : 'text-[var(--q3-indigo-normal)]'} whitespace-nowrap`}
          >
            <SparkleIcon size={isMobile ? 16 : 20} weight="fill" />
            {isProjected ? 'Potential' : 'Predicted'}{' '}
            {percentileData?.combinedScore || percentile?.combinedScore === 'null' ? 'Rank' : 'Percentile'}
          </div>
          {percentile?.data && (
            <p
              className={`md:text-6xl text-5xl font-black ${!isProjected ? 'text-[var(--q3-indigo-normal)]' : 'text-[var(--q3-teal-normal)]'} pt-0 md:pt-3`}
            >
              {Number(percentile?.data) ? Number(percentile?.data)?.toFixed(2) : percentile?.data}
            </p>
          )}
          {!percentile?.combinedScore && percentile?.data && !isProjected && (
            <p className="text-xs text-[var(--q3-neutral-light)]">Exact Percentile: {percentile?.data}%ile</p>
          )}
        </div>
        {!percentile?.data && <p className="text-xs max-w-[280px]">{percentileData?.consolationText}</p>}

        {/* Bottom Description */}
        <p className="text-xs text-[var(--q3-neutral-default)] mt-3 md:mt-0">
          {!isProjected
            ? extractData(percentileData?.description)
              ? `Prediction is done based on ${extractData(percentileData?.description)} data`
              : percentileData?.description
            : 'This is your Potential Percentile, calculated using patterns from JEE Main 2025 data'}
        </p>
      </div>
    </div>
  );
};

export default PercentileCard;

function extractData(text) {
  const regex = /JEE Main \d{4} \(\d{1,2} [A-Za-z]+ Shift \d+\)/;
  const match = text?.match(regex);
  return match ? match[0] : null;
}
